import { BaseState } from '@app/core/store/_prototypes/action-reducers/state/base.state';
import { createSelector } from '@ngrx/store';

const success = <T>(state: (state: any) => BaseState<T>) => createSelector(state, (s) => s.success);
const data = <T>(state: (state: any) => BaseState<T>) => createSelector(state, (s) => s.data);
const busy = <T>(state: (state: any) => BaseState<T>) => createSelector(state, (s) => s.busy);
const failed = <T>(state: (state: any) => BaseState<T>) => createSelector(state, (s) => !!s.failed);
const failedWithError = <T>(state: (state: any) => BaseState<T>) => createSelector(state, (s) => s.failed);

export const baseSelector = <T>(state: (state: any) => BaseState<T>) => ({
  success: success(state),
  data: data(state),
  busy: busy(state),
  failed: failed(state),
  failedWithError: failedWithError(state),
});
